import { useState } from 'react';

const LoadingImage = ({ src, alt, className, onLoad }) => {
  const [isLoaded, setIsLoaded] = useState(false);

  return (
    <div className="relative w-full h-full">
      {!isLoaded && (
        <div className="absolute inset-0 bg-gray-100 rounded-xl animate-pulse">
          <div className="flex justify-center items-center h-full">
            <div className="w-8 h-8 rounded-full border-2 animate-spin border-stone-600 border-t-transparent"></div>
          </div>
        </div>
      )}
      <img
        src={src}
        alt={alt}
        className={`${className} ${isLoaded ? 'opacity-100' : 'opacity-0'} transition-opacity duration-300`}
        onLoad={() => {
          setIsLoaded(true);
          onLoad?.();
        }}
      />
    </div>
  );
};

export default LoadingImage;
